<template>
  <v-alert v-model="local" type="error" dismissible transition="scale-transition" class="subheading mx-0">
    <p class="pb-0 mb-0" v-for="(error, index) in errors" :key="index">
      {{ error }}
    </p>
  </v-alert>
</template>

<script>
export default {
  name: 'FormErrors',
  data: () => ({
    local: false
  }),
  props: {
    show: { type: Boolean, default: false },
    errors: Array
  },
  watch: {
    show: function (val) {
      this.local = val
    }
  }
}
</script>

<style></style>
